import React from 'react';
import { FileText, Download, User, Calendar, FileCheck } from 'lucide-react';

const MemorandumsSection = ({ caseData, portalType = 'individual' }) => {
  const primaryColor = portalType === 'business' ? '#1E3A8A' : '#10B981';
  return (
    <div className="bg-white rounded-xl shadow-sm border-2 border-gray-200 p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-[#059669] to-[#10B981] rounded-xl flex items-center justify-center">
          <FileText className="w-7 h-7 text-white" strokeWidth={2.5} />
        </div>
        <h2 className="text-3xl font-black  style={{ color: primaryColor }}">المذكرات القانونية</h2>
      </div>

      {caseData.memorandums && caseData.memorandums.length > 0 ? (
        <div className="space-y-6">
          {caseData.memorandums.map((memo) => (
            <div 
              key={memo.id}
              className="border-2 border-gray-200 rounded-xl p-6 hover:border-[#059669] transition-all hover:shadow-lg bg-white"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#059669] to-[#10B981] rounded-xl flex items-center justify-center">
                    <FileCheck className="w-6 h-6 text-white" strokeWidth={2.5} />
                  </div>
                  <div>
                    <h3 className="text-xl font-black text-gray-900">{memo.title}</h3>
                    <span className="inline-block px-3 py-1 bg-emerald-100 text-emerald-800 rounded-full text-xs font-bold mt-1">
                      {memo.type}
                    </span>
                  </div>
                </div>
                {memo.canDownload && (
                  <button className="px-4 py-2 bg-[#C8A870] hover:bg-[#1E3A8A] text-white rounded-lg transition-colors flex items-center gap-2 font-bold">
                    <Download className="w-4 h-4" />
                    <span>تحميل</span>
                  </button>
                )}
              </div>

              <p className="text-gray-700 mb-4 leading-relaxed">{memo.summary}</p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4 border-t border-gray-100">
                <div className="flex items-center gap-3 text-gray-700">
                  <User className="w-5 h-5  style={{ color: primaryColor }}" />
                  <div>
                    <div className="text-xs text-gray-500 font-semibold">مقدم من</div>
                    <div className="font-bold">{memo.submittedBy}</div>
                  </div>
                </div>
                
                <div className="flex items-center gap-3 text-gray-700">
                  <Calendar className="w-5 h-5  style={{ color: primaryColor }}" />
                  <div>
                    <div className="text-xs text-gray-500 font-semibold">تاريخ التقديم</div>
                    <div className="font-bold">{memo.submissionDate}</div>
                  </div>
                </div>

                <div className="flex items-center gap-3 text-gray-700">
                  <FileText className="w-5 h-5  style={{ color: primaryColor }}" />
                  <div>
                    <div className="text-xs text-gray-500 font-semibold">عدد الصفحات</div>
                    <div className="font-bold">{memo.pages} صفحة</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 text-gray-500">
          <FileText className="w-16 h-16 mx-auto mb-4 text-gray-300" />
          <p className="text-lg font-bold">لا توجد مذكرات مقدمة</p>
        </div>
      )}
    </div>
  );
};

export default MemorandumsSection;